import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';
import FaqModal from 'containers/FaqModal';
import TermsOfServiceModal from 'containers/TermsOfServiceModal';
import AuthBottom from 'components/AuthBottom';
import AuthTop from 'components/AuthTop';
import Input from 'components/Input';
import ViewablePasswordField from 'components/ViewablePasswordField';
import Validators, { birthdayParse } from 'utils/fieldValidators';
import { isLocationPls } from 'utils/locations';
import {
  DISPLAY_NAME_RULE_DESCRIPTION,
  PASSWORD_RULE_DESCRIPTION
} from 'utils/messages';
import {
  FORM_NAME,
  FaqLink,
  GENDER_OPTIONS,
  LANGUAGE_OPTIONS,
  SubmitStatus,
  TermsOfServiceLink
} from '../formConstants';
import './NewMemberFormPage.css';

class NewMemberFormPage extends Component {
  constructor(props) {
    super(props);

    this.scrollTopRef = React.createRef();

    this.state = {
      showPassword: false,
      showTos: false,
      showFaq: false
    };
  }

  componentDidMount() {
    this.scrollTopRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  openTos = event => {
    event && event.preventDefault();
    this.setState({ showTos: true });
  };

  closeTos = () => {
    this.setState({ showTos: false });
  };

  openFaq = event => {
    event && event.preventDefault();
    this.setState({ showFaq: true });
  };

  closeFaq = () => {
    this.setState({ showFaq: false });
  };

  render() {
    const { formRenderer, preferredLocation } = this.props;
    const tosLabel = <TermsOfServiceLink onClick={this.openTos} />;

    const body = (
      <Fragment>
        <div className="top-scroll-ref" ref={this.scrollTopRef} />
        <AuthTop hideLogo>
          <div className="form-page new-member-form-page">
            <Field
              name="email"
              component={Input}
              type="email"
              label="Email Address*"
              autoComplete="email username"
              disableOnSubmitting={true}
              tooltip="You will login with your email address"
              validate={Validators.trimmedEmail}
              required
            />
            <Field
              name="confirmEmail"
              component={Input}
              type="email"
              label="Confirm Email*"
              autoComplete="email username"
              disableOnSubmitting={true}
              validate={Validators.reduxConfirmEmail}
              required
            />
            <Field
              name="password"
              component={ViewablePasswordField}
              showPassword={this.state.showPassword}
              toggleVisibility={this.togglePasswordVisibility}
              label="Password*"
              autoComplete="new-password"
              disableOnSubmitting={true}
              tooltip={PASSWORD_RULE_DESCRIPTION}
              validate={Validators.password}
              required
            />
            <Field
              name="confirmPassword"
              component={ViewablePasswordField}
              showPassword={this.state.showPassword}
              label="Confirm Password*"
              autoComplete="new-password"
              disableOnSubmitting={true}
              validate={Validators.reduxConfirmPassword}
              required
            />
            <Field
              name="displayName"
              component={Input}
              type="text"
              label="Display Name*"
              autoComplete="nickname"
              disableOnSubmitting={true}
              tooltip={`This is the name that will be displayed to others when you post on the site. ${DISPLAY_NAME_RULE_DESCRIPTION}`}
              validate={Validators.trimmedDisplayName}
              required
            />
            <Field
              name="dateOfBirth"
              component={Input}
              type="text"
              label="Date of Birth*"
              autoComplete="bday"
              placeholder="MM/DD/YYYY"
              disableOnSubmitting={true}
              parse={birthdayParse}
              validate={Validators.birthday}
              required
            />
            {isLocationPls(preferredLocation) && (
              <Field
                name="gender"
                component={Input}
                type="select"
                label="Gender*"
                placeholder="Select"
                disableOnSubmitting={true}
                validate={Validators.required}
                required
              >
                {GENDER_OPTIONS}
              </Field>
            )}
            <Field
              name="preferredLanguage"
              component={Input}
              type="select"
              label="Language*"
              placeholder="Select"
              disableOnSubmitting={true}
              validate={Validators.required}
              required
              icon={<div className="dropdown-icon" />}
            >
              {LANGUAGE_OPTIONS}
            </Field>
            <Field
              name="agreeToTOS"
              component={Input}
              type="checkbox"
              label="Terms Of Service"
              labelNode={tosLabel}
              disableOnSubmitting={true}
              wrapperClass="form-tos"
              validate={Validators.termsOfService}
              aria-label="Terms of Service Checkbox"
              required
            />
            <TermsOfServiceModal
              onHide={this.closeTos}
              show={this.state.showTos}
            />
            <FaqModal onHide={this.closeFaq} show={this.state.showFaq} />
          </div>
        </AuthTop>
        <AuthBottom className="new-member-form-bottom ">
          <button
            className={`btn button-color-green btn-block`}
            disabled={this.props.submitting || !this.props.valid}
            type="submit"
          >
            {this.props.submitText}
            <SubmitStatus submitting={this.props.submitting} />
          </button>
          <FaqLink onClick={this.openFaq} />
        </AuthBottom>
      </Fragment>
    );

    return formRenderer(this.props, body);
  }
}

const formSelector = formValueSelector(FORM_NAME);
const mapStateToProps = createStructuredSelector({
  preferredLocation: state => formSelector(state, 'preferredLocation')
});

const withConnect = connect(mapStateToProps);

const reduxFormPage = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(NewMemberFormPage);

reduxFormPage.FormFields = [
  'email',
  'displayName',
  'password',
  'confirmPassword',
  'dateOfBirth',
  'gender',
  'preferredLanguage',
  'agreeToTOS'
];

export default withConnect(reduxFormPage);
